import { bl_svc_issue_attachment_RowClass } from '../../../dbschema/bl_svc_issue_attachment.model';
import { BaseContainerModel } from '../../base-container.model';


export class ServiceIssueAttchmentContainerModel extends BaseContainerModel {
  bl_svc_issue_attachment: bl_svc_issue_attachment_RowClass = new bl_svc_issue_attachment_RowClass();
}
